/** Laturile unui cub n×n×n: pentru fiecare față, ce nod corespunde fiecărui vertex al suprafeței. */
export function cubeSurface(n: number): { vertexNode: Uint32Array; index: Uint32Array } {
  const id = (i: number, j: number, k: number) => i + n * (j + n * k);
  const vertexNode: number[] = [];
  const index: number[] = [];
  // fiecare față: axa fixă, valoarea ei, cele două axe care o parcurg, semnul normalei spre exterior
  const faces: Array<{ fixed: number; at: number; u: number; v: number; outward: number }> = [
    { fixed: 0, at: 0, u: 2, v: 1, outward: -1 },
    { fixed: 0, at: n - 1, u: 2, v: 1, outward: 1 },
    { fixed: 1, at: 0, u: 0, v: 2, outward: -1 },
    { fixed: 1, at: n - 1, u: 0, v: 2, outward: 1 },
    { fixed: 2, at: 0, u: 0, v: 1, outward: -1 },
    { fixed: 2, at: n - 1, u: 0, v: 1, outward: 1 }
  ];
  for (const f of faces) {
    const base = vertexNode.length;
    for (let b = 0; b < n; b++) {
      for (let a = 0; a < n; a++) {
        const c = [0, 0, 0];
        c[f.fixed] = f.at;
        c[f.u] = a;
        c[f.v] = b;
        vertexNode.push(id(c[0], c[1], c[2]));
      }
    }
    // ordinea triunghiurilor: normala (u × v) trebuie să iasă din cub
    const uv = [0, 0, 0];
    const ua = [0, 0, 0];
    const va = [0, 0, 0];
    ua[f.u] = 1;
    va[f.v] = 1;
    uv[0] = ua[1] * va[2] - ua[2] * va[1];
    uv[1] = ua[2] * va[0] - ua[0] * va[2];
    uv[2] = ua[0] * va[1] - ua[1] * va[0];
    const flip = uv[f.fixed] * f.outward < 0;
    for (let b = 0; b < n - 1; b++) {
      for (let a = 0; a < n - 1; a++) {
        const p0 = base + a + b * n;
        const p1 = p0 + 1;
        const p2 = p0 + n;
        const p3 = p2 + 1;
        if (flip) index.push(p0, p2, p1, p1, p2, p3);
        else index.push(p0, p1, p2, p1, p3, p2);
      }
    }
  }
  return { vertexNode: Uint32Array.from(vertexNode), index: Uint32Array.from(index) };
}
